const localReviewHosts = new Set(['localhost', '127.0.0.1', '192.168.68.157']);

// A local-only visual review mode. It unlocks the page shell without creating
// a pretend user or supplying fabricated API data.
export const isLocalVisualReview =
  process.env.NODE_ENV !== 'production' ||
  (typeof window !== 'undefined' && localReviewHosts.has(window.location.hostname));
